<template>
  <svg
    class="ex-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-html="markup"
  ></svg>
</template>

<script>
// Central inline-SVG icon set for the Exchange, matching the stroke-based
// icon style used across the app (Wallet etc.). No external icon font.
const ICONS = {
  "bar-chart": '<path d="M3 21h18"/><path d="M7 21V10"/><path d="M12 21V4"/><path d="M17 21v-7"/>',
  storefront:
    '<path d="M4 9l1.2-5h13.6L20 9"/><path d="M4 9v10a1 1 0 001 1h14a1 1 0 001-1V9"/><path d="M4 9h16"/><path d="M9 20v-5h6v5"/>',
  percent:
    '<path d="M19 5L5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>',
  swap:
    '<path d="M7 10L3 6l4-4"/><path d="M3 6h13a4 4 0 014 4"/><path d="M17 14l4 4-4 4"/><path d="M21 18H8a4 4 0 01-4-4"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',
  close: '<path d="M6 6l12 12"/><path d="M18 6L6 18"/>',
  payments: '<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/>',
  chevron: '<path d="M6 9l6 6 6-6"/>',
  arrow: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
  fire:
    '<path d="M12 3s5 3.5 5 9a5 5 0 01-10 0c0-1.2.4-2.2.4-2.2S5 12 5 14a7 7 0 0014 0c0-6-7-11-7-11z"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
  "trending-up": '<path d="M3 17l6-6 4 4 8-8"/><path d="M16 7h5v5"/>',
  hourglass:
    '<path d="M6 3h12"/><path d="M6 21h12"/><path d="M8 3v3a4 4 0 004 4 4 4 0 004-4V3"/><path d="M8 21v-3a4 4 0 014-4 4 4 0 014 4v3"/>',
  tag:
    '<path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0l-7-7A2 2 0 013 12.2V4.8A1.8 1.8 0 014.8 3h7.4a2 2 0 011.4.6l7 7a2 2 0 010 2.8z"/><circle cx="7.5" cy="7.5" r="1.2"/>',
  bolt: '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>',
  "arrow-down": '<path d="M12 5v14"/><path d="M6 13l6 6 6-6"/>',
  "search-off":
    '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M8.5 8.5l5 5"/>',
  box:
    '<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>',
};

export default {
  name: "ExIcon",
  props: {
    name: { type: String, required: true },
  },
  computed: {
    markup() {
      return ICONS[this.name] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.ex-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: middle;
}
</style>
